import React, {useEffect, useState} from "react";
import { Box, Typography } from '@mui/material';
import moment from "moment";
import QRCode from 'qrcode';
import 'moment/locale/fr'; // Import French locale for moment.js


export default function Billet({ billet }) {
    const billetRef = React.useRef(null);
    const [Qrimg, setQrImg] = useState(null);


    useEffect(() => {
        QRCode.toDataURL(billet.num, { width: '100px' }, (err, url) => {
        if (err) return console.error(err);
        setQrImg(url);
        });
    }, [billet.num]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <Box ref={billetRef}
            sx={{ width: '800px', height: '240px', backgroundColor: '#ede5e3', display: 'flex', position: 'relative', overflow: 'hidden', 
                fontFamily: 'Montserrat, sans-serif',
            }}>
                {/* Left image */}
                <div style={{ width: '240px', height: '240px', overflow: 'hidden' }}>
                    <img
                        src={process.env.REACT_APP_API_URL + billet.event.image}
                        style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                        }}
                        alt="Affiche"
                    />
                </div>

                {/* Ticket body */}
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'row', position: 'relative' }}>
                        {/* Info Section */}
                    <Box sx={{flex: 1, padding: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                            {/* Event type & address */}
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography fontSize={12} textTransform='uppercase' fontWeight="bold">
                                    {billet.event.type}
                                </Typography>
                                <Typography fontSize={12} fontWeight="bold" sx={{ textAlign: 'right', whiteSpace: 'pre-line' }}>
                                    {billet.event.lieu}
                                </Typography>
                            </Box>

                            {/* Title */}
                            <Typography
                            component="h1"
                            sx={{marginTop: '10px', fontSize: '38px', lineHeight: '40px', height: '80px', overflow: 'hidden', 
                            fontFamily: 'Archivo Black, sans-serif'}}>
                                {billet.event.titre}
                            </Typography>

                            {/* Footer Info */}
                            <Box sx={{position: 'absolute', display:'flex', flexDirection:'column', width:'100%', left: 0, bottom: 10}}>
                                <Typography fontWeight="bold" fontSize={12} sx={{ marginLeft: '20%', marginBlock: '10px', textTransform:'uppercase' }}>
                                    {billet.owner.nom} {billet.owner.prenom}
                                </Typography>

                                <Box sx={{ display: 'flex', justifyContent: 'space-between', px:'20px' }}>
                                    {[moment.utc(billet.event.date).format('D MMM'), billet.event.heure.replace(':', 'H'), 'prix: '+billet.price?.toFixed(2)+' €'].map((item, idx) => (
                                    <Typography
                                        key={idx}
                                        sx={{
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textTransform: 'uppercase',
                                        padding: '5px 15px',
                                        border: '1px solid black',
                                        borderRadius: '25px',
                                        }}
                                    >
                                        {item}
                                    </Typography>
                                    ))}
                                </Box>

                                <Typography sx={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'center', marginTop: '10px' }}>
                                    {billet.num}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>

                {/* Separator */}
                <Box
                sx={{ width: '2px', borderLeft: '2px dashed #fff', marginX: '1px', position: 'relative',
                    '&::before, &::after': {content: '""', width: '30px', height: '30px', backgroundColor: '#fff', borderRadius: '50%', position: 'absolute', left: '-15px'},
                    '&::before': {top: '-16px'},
                    '&::after': { bottom: '-16px'},
                }}
                />

                {/* QR Section */}
                <Box
                sx={{
                    width: '140px',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: 0,
                }}
                >
                    {Qrimg ? <img
                        src={Qrimg}
                        alt="QR Code"
                        style={{ width: '100px', height: '100px', marginLeft: '10px' }}
                    /> : <Box sx={{width: '100px', height: '100px'}}></Box>}
                    <Box
                    sx={{
                        transform: 'rotate(-90deg)',
                        transformOrigin: 'left top',
                        fontWeight: 'bold',
                        fontSize: '10px',
                        whiteSpace: 'nowrap',
                        position: 'absolute',
                        top: '164px',
                        right: '-60px',
                        // left: '30px',
                        // width: '100px',
                    }}
                    >
                        {billet.num}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
